(function() {
  "use strict";
  function initFadeUp() {
    var els = document.querySelectorAll(".fade-up");
    var i;
    if (!els.length || !("IntersectionObserver" in window)) {
      for (i = 0; i < els.length; i++) {
        els[i].classList.add("is-visible");
      }
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      var j;
      for (j = 0; j < entries.length; j++) {
        if (entries[j].isIntersecting) {
          entries[j].target.classList.add("is-visible");
          observer.unobserve(entries[j].target);
        }
      }
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    for (i = 0; i < els.length; i++) {
      observer.observe(els[i]);
    }
  }
  function openCartDrawer() {
    var drawer = document.getElementById("CartDrawer");
    var overlay = document.getElementById("CartDrawerOverlay");
    if (!drawer) return;
    drawer.classList.add("is-open");
    if (overlay) overlay.classList.add("is-visible");
    document.body.style.overflow = "hidden";
  }
  function closeCartDrawer() {
    var drawer = document.getElementById("CartDrawer");
    var overlay = document.getElementById("CartDrawerOverlay");
    if (drawer) drawer.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-visible");
    document.body.style.overflow = "";
  }
  window.initCartDrawer = function initCartDrawer() {
    if (document.documentElement.hasAttribute("data-cart-bound")) return;
    document.documentElement.setAttribute("data-cart-bound", "");
    document.addEventListener("click", function(e) {
      var openEl = e.target.closest ? e.target.closest("[data-cart-open]") : null;
      var closeEl = e.target.closest ? e.target.closest("[data-cart-close]") : null;
      if (openEl) {
        e.preventDefault();
        openCartDrawer();
        return;
      }
      if (closeEl) {
        closeCartDrawer();
      }
    });
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape") closeCartDrawer();
    });
  };
  document.addEventListener("click", function(e) {
    var wrap;
    var input;
    if (e.target.matches("[data-quantity-plus]")) {
      wrap = e.target.closest ? e.target.closest(".quantity") : null;
      input = wrap ? wrap.querySelector('input[type="number"]') : null;
      if (input) {
        input.value = Math.min(parseInt(input.value || 1, 10) + 1, parseInt(input.max || 99, 10));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
    if (e.target.matches("[data-quantity-minus]")) {
      wrap = e.target.closest ? e.target.closest(".quantity") : null;
      input = wrap ? wrap.querySelector('input[type="number"]') : null;
      if (input) {
        input.value = Math.max(parseInt(input.value || 1, 10) - 1, parseInt(input.min || 1, 10));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initFadeUp();
      initCartDrawer();
    });
  } else {
    initFadeUp();
    initCartDrawer();
  }
})();

(function() {
  "use strict";
  function moneyFromCents(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency: currency || "USD" });
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }
  function updateCartCount(count) {
    var els = document.querySelectorAll("[data-cart-count]");
    var i;
    var el;
    for (i = 0; i < els.length; i++) {
      el = els[i];
      el.textContent = String(count || 0);
      if (el.hasAttribute("hidden") || el.hidden) {
        el.hidden = !(count > 0);
      }
    }
  }
  function refreshCartDrawer() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return Promise.resolve();
    return fetch("/?section_id=cart-drawer")
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var next = doc.getElementById("CartDrawer");
        var nextOverlay = doc.getElementById("CartDrawerOverlay");
        if (next) drawer.replaceWith(next);
        var overlay = document.getElementById("CartDrawerOverlay");
        if (nextOverlay && overlay) overlay.replaceWith(nextOverlay);
        var openDrawer = document.getElementById("CartDrawer");
        var openOverlay = document.getElementById("CartDrawerOverlay");
        if (openDrawer) openDrawer.classList.add("is-open");
        if (openOverlay) openOverlay.classList.add("is-visible");
        document.body.style.overflow = "hidden";
        if (window.initCartDrawer) window.initCartDrawer();
      })
      .catch(function() {});
  }
  document.addEventListener("submit", function(e) {
    var form = e.target.closest ? e.target.closest("form[data-product-form], form[action*='/cart/add']") : null;
    if (!form) return;
    if (form.hasAttribute("data-no-ajax")) return;
    e.preventDefault();
    var btn = form.querySelector("[type='submit']");
    if (btn) { btn.disabled = true; }
    var body = new FormData(form);
    fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: body })
      .then(function(r) {
        return r.json().then(function(data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function(result) {
        if (!result.ok) {
          window.location.href = form.getAttribute("action") || "/cart";
          return;
        }
        return fetch("/cart.js").then(function(r) { return r.json(); }).then(function(cart) {
          updateCartCount(cart.item_count);
          return refreshCartDrawer();
        });
      })
      .catch(function() {
        window.location.href = "/cart";
      })
      .then(function() {
        if (btn) btn.disabled = false;
      }, function() {
        if (btn) btn.disabled = false;
      });
  });
  function initStickyAtc() {
    var bar = document.querySelector("[data-sticky-atc]");
    var hero = document.querySelector("[data-hero]");
    if (!bar) return;
    function show(on) {
      if (on) {
        bar.classList.add("is-visible");
        document.body.classList.add("has-sticky-atc");
      } else {
        bar.classList.remove("is-visible");
        document.body.classList.remove("has-sticky-atc");
      }
    }
    if (!hero || !("IntersectionObserver" in window)) {
      var onScroll = function() {
        show(window.scrollY > 420);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      var i;
      for (i = 0; i < entries.length; i++) {
        show(!entries[i].isIntersecting);
      }
    }, { threshold: 0.08 });
    io.observe(hero);
  }
  function initHeaderNav() {
    if (document.documentElement.hasAttribute("data-nav-bound")) return;
    document.documentElement.setAttribute("data-nav-bound", "");
    document.addEventListener("click", function(e) {
      var toggle = e.target.closest ? e.target.closest("[data-nav-toggle]") : null;
      if (!toggle) return;
      var header = document.querySelector(".header");
      if (!header) return;
      var open = header.classList.toggle("is-nav-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }
  function moneyFromCentsLocal(cents) {
    try {
      return (Number(cents) / 100).toLocaleString(undefined, { style: "currency", currency: "USD" });
    } catch (err) {
      return "$" + (Number(cents) / 100).toFixed(2);
    }
  }
  function applyPackSelection(card) {
    if (!card || card.disabled) return;
    var id = card.getAttribute("data-variant-id");
    var qty = Number(card.getAttribute("data-qty") || 1);
    var priceHtml = card.getAttribute("data-price-html") || "";
    var per = Number(card.getAttribute("data-per") || 0);
    var save = Number(card.getAttribute("data-save") || 0);
    var cta = card.getAttribute("data-cta") || "GET DEEP FOCUS DAILY";
    var ship = card.getAttribute("data-ship") || "Free U.S. Shipping";
    var i;
    var el;
    var on;
    var els = document.querySelectorAll("[data-pack-card]");
    for (i = 0; i < els.length; i++) {
      el = els[i];
      on = el === card;
      if (on) {
        el.classList.add("is-selected");
      } else {
        el.classList.remove("is-selected");
      }
      el.setAttribute("aria-checked", on ? "true" : "false");
    }
    els = document.querySelectorAll("[data-variant-id]");
    for (i = 0; i < els.length; i++) {
      el = els[i];
      if (!el.hasAttribute("data-pack-card")) {
        if (el.getAttribute("data-variant-id") === id) {
          el.classList.add("is-selected");
        } else {
          el.classList.remove("is-selected");
        }
      }
    }
    els = document.querySelectorAll('form[data-product-form] input[name="id"], [data-pack-id-input]');
    for (i = 0; i < els.length; i++) {
      if (id) els[i].value = id;
    }
    els = document.querySelectorAll('form[data-product-form] input[name="quantity"]');
    for (i = 0; i < els.length; i++) {
      els[i].value = "1";
    }
    els = document.querySelectorAll("[data-pack-total]");
    for (i = 0; i < els.length; i++) {
      els[i].textContent = priceHtml;
    }
    els = document.querySelectorAll("[data-sticky-price]");
    for (i = 0; i < els.length; i++) {
      els[i].textContent = priceHtml;
    }
    els = document.querySelectorAll("[data-pack-per-wrap]");
    for (i = 0; i < els.length; i++) {
      els[i].hidden = qty < 2;
    }
    els = document.querySelectorAll("[data-pack-per]");
    for (i = 0; i < els.length; i++) {
      els[i].textContent = qty >= 2 ? (moneyFromCentsLocal(per) + " per bottle") : "";
    }
    els = document.querySelectorAll("[data-pack-save-wrap]");
    for (i = 0; i < els.length; i++) {
      els[i].hidden = !(save > 0);
    }
    els = document.querySelectorAll("[data-pack-save]");
    for (i = 0; i < els.length; i++) {
      els[i].textContent = save > 0 ? ("Save " + moneyFromCentsLocal(save)) : "";
    }
    els = document.querySelectorAll("[data-pack-ship]");
    for (i = 0; i < els.length; i++) {
      els[i].textContent = ship;
    }
    els = document.querySelectorAll("[data-pack-atc]");
    for (i = 0; i < els.length; i++) {
      els[i].textContent = cta;
    }
    els = document.querySelectorAll("[data-sticky-pack-label]");
    for (i = 0; i < els.length; i++) {
      if (qty === 3) {
        els[i].textContent = "3 Bottles";
      } else if (qty === 2) {
        els[i].textContent = "2 Bottles";
      } else {
        els[i].textContent = "1 Bottle";
      }
    }
  }
  document.addEventListener("click", function(e) {
    var card = e.target.closest ? e.target.closest("[data-pack-card]") : null;
    var pill;
    var id;
    var els;
    var i;
    if (card) {
      e.preventDefault();
      applyPackSelection(card);
      return;
    }
    pill = e.target.closest ? e.target.closest("[data-variant-id]") : null;
    if (!pill) return;
    id = pill.getAttribute("data-variant-id");
    els = document.querySelectorAll('form[data-product-form] input[name="id"], [data-pack-id-input]');
    for (i = 0; i < els.length; i++) {
      if (id) els[i].value = id;
    }
    els = document.querySelectorAll("[data-variant-id]");
    for (i = 0; i < els.length; i++) {
      if (els[i] === pill) {
        els[i].classList.add("is-selected");
      } else {
        els[i].classList.remove("is-selected");
      }
    }
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initStickyAtc();
      initHeaderNav();
    });
  } else {
    initStickyAtc();
    initHeaderNav();
  }
})();
